// Components
import useTranslate from "hooks/useTranslate";
import PartnerItem from "../PartnerItem";

// Icons
import IconGamblGlory from "../../../assets/icons/glory/info_gamb_glory.svg?react";
import IconGambling from "../../../assets/icons/banger/info_gambling.svg?react";
import GloryPartners from "../../../assets/icons/glory/glory_partners.svg?react";
import BangerGloryPartners from "../../../assets/icons/banger/glory_partners.svg?react";

// Hooks

import "./styles.sass";

const PartnersInfo = () => {
  const t = useTranslate();
  const { VITE_APP_PROJECT_NAME } = import.meta.env;
  const iconGamble =
    VITE_APP_PROJECT_NAME === "glory" ? <IconGamblGlory /> : <IconGambling />;
  const iconPartner =
    VITE_APP_PROJECT_NAME === "glory" ? (
      <GloryPartners />
    ) : (
      <BangerGloryPartners />
    );

  return (
    <div className="PartnersInfo">
      <div className="PartnersInfo__back" />
      <span className="PartnersInfo__title">
        {t("info.about.partners.header")}
      </span>
      <PartnerItem
        title="info.about.partners.gambling"
        description="info.partners.gambling.desc"
        icon={iconGamble}
      />
      <PartnerItem
        title="footer.partners"
        description="info.partners.program.desc"
        icon={iconPartner}
      />
    </div>
  );
};

export default PartnersInfo;
